import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { NewsletterPopup } from "@/components/NewsletterPopup";
import { SupportChat } from "@/components/SupportChat";

export const SiteLayout = () => {
  const { pathname } = useLocation();

  // Scroll to top + replay page-fade on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <SiteHeader />
      <main className="flex-1 page-enter" key={pathname}>
        <Outlet />
      </main>
      <SiteFooter />
      <NewsletterPopup />
      <SupportChat />
    </div>
  );
};